import React from "react";
import { Modal, Form, Input, Button } from "antd";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const EditQRModal = ({ visible, qrCode, onClose, onEdit }) => {
  const [form] = Form.useForm();
  const { language } = useLanguage();
  const text = dashboardContent[language].qr.editModal;

  React.useEffect(() => {
    if (qrCode) {
      form.setFieldsValue({ name: qrCode.name, data: qrCode.data });
    }
  }, [qrCode, form]);

  const handleFinish = (values) => {
    onEdit({ ...qrCode, ...values }); // Merge updated values with the existing QR code
    form.resetFields(); // Reset the form fields
    onClose(); // Close the modal
  };

  return (
    <Modal
      visible={visible}
      title={text.title}
      onCancel={() => {
        form.resetFields(); // Reset the form on cancel
        onClose();
      }}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="name"
          label={text.nameLabel}
          rules={[{ required: true, message: text.nameRequired }]}
        >
          <Input placeholder={text.namePlaceholder} />
        </Form.Item>

        <Form.Item
          name="data"
          label={text.urlLabel}
          rules={[{ required: true, message: text.urlRequired }]}
        >
          <Input placeholder={text.urlPlaceholder} />
        </Form.Item>

        <Form.Item>
          <button
            className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
            htmlType="submit"
            block
          >
            {text.save}
          </button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditQRModal;
